<template>
	<div class="head_img2 flex2">
		<img :src="imgurl">
	</div>
</template>

<script>
export default {
	props: {
		imgurl: {
			type: String,
			required: true,
		},
	},
}
</script>

<style lang="scss">
.head_img2 {
    width: 100%;
    height: 4rem;
    overflow: hidden;
	img {
		width: auto;
		height: 5rem;
        margin-left: 10rem;
        margin-top: 0.5rem;
	}
}
</style>